
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/compliance-lite",
      function () {
        return require("private-next-pages/products/compliance-lite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/compliance-lite"])
      });
    }
  